import { TourStep } from '../../models/tour.model';

export const DEAL_PAGE_TOUR: TourStep[] = [
  {
    title: 'Working with Deals',
    intro: `
        <p>Welcome to the <b>Deal Page</b> in Semeris Docs — your one-stop destination for <b>single-deal research</b>.</p>
        <p>During this tour, you'll learn about:</p>
        <ul>
            <li>The Checklists panel</li>
            <li>The Docs & Blacklines panel</li>
            <li>Customizing your view</li>
            <li>Additional analysis panels</li>
            <li>Research Layouts for specific use cases</li>
        </ul>
        <p><i>Let's get started!</i></p>
    `,
  },
  {
    title: 'Checklists panel',
    element: 'div.summary',
    intro: `
        <p>The <b>Checklists panel</b> offers curated and customizable <b>deal summaries</b>.</p>
        <p><b>Analyst verified</b> information is marked with the <i class="material-icons">verified_user</i> icon.</p>
        <p>Summaries link to their corresponding deal documents:</p>
        <ul>
          <li>Click gray <b>source references</b>, e.g. <span style="color: darkgray; text-decoration: underline;">[1] p27</span>,</li>
          <li>Click any extracted paragraph to jump to its position in the document.</li>
        </ul>
    `,
  },
  {
    title: 'Docs & Blacklines',
    element: 'div.document',
    intro: `
        <p>The <b>Docs & Blacklines</b> panel includes the <b>document viewer</b> and a tool to generate <b>smart blacklines</b>.</p>
        <p>You can click&drag the panel separators to resize panels as needed.</p>
    `,
  },
  {
    title: 'Switch Between Deal Documents',
    element: 'semeris-document-comparison-header .document-selectors div',
    intro: `
        <p>If a deal has <b>multiple documents</b>, you can switch between them here.</p>
    `,
  },
  {
    title: 'View the Original PDF',
    element: 'semeris-document-comparison-header .actions .semeris-flat-switch-wrapper',
    intro: `
        <p>Our Semeris Viewer with <b>X-Ray</b> offers the best reading experience.</p>
        <p>Still, the <b>original document</b> (e.g. a PDF) is available by toggling to <b>Source</b>.</p>
    `,
  },
  {
    title: 'Generating Blacklines',
    element: 'semeris-document-comparison-header #blackline-button',
    intro: `
        <p>You can <b>generate your own blacklines</b> by pressing this button and selecting a document from other deals.</p>
    `,
  },
  {
    title: 'Panel Menu and Closing Panels',
    element: 'div.summary #panel-menu',
    intro: `
        <p>Each panel features a <i class="material-icons">more_vert</i> menu with panel-specific options.</p>
        <p>For assistance with a panel, look for <i class="material-icons">help</i> Help in its menu.</p>
    `,
  },
  {
    title: 'Closing Panels',
    element: 'div.summary #hide-panel-button',
    intro: `
        <p>Use the <i class="material-icons">close</i> icon to hide panels and free up space when needed.</p>
    `,
  },
  {
    title: 'Additional analysis panels',
    element: '.split-view-toggle-buttons',
    intro: `
        <p>Explore various panels to expand your analysis. Use the toggle buttons to switch them on or off.</p>
        <ul>
          <li><b>Datapoints</b> - Searchable table of structured data.</li>
          <li><b>Checklists</b> - Summaries built from topics.</li>
          <li><b>Docs & Blacklines</b> - View documents with Semeris X-Ray.</li>
          <li><b>Similar Paragraphs</b> - Displays similar paragraphs across deals.</li>
          <li><b>Term Explorer</b> - List of defined terms and usage frequency.</li>
          <li><b>Data Tables</b> - Download data from document tables.</li>
          <li><b>Clippings</b> - Your exportable text snippets from the document.</li>
        </ul>
        <p>For optimal viewing, use 2 panels on smaller screens and 3 on larger ones.</p>
    `,
  },
  {
    title: 'Research Layouts',
    element: '.buttons #deal-page-menu',
    intro: `
        <p>Within the <b>Three Dot Menu</b>, you will find a set of <b>Research Layouts</b> offering preset configurations for key use cases:</p>
        <ul style="list-style-type: none;">
          <li><i class="material-icons" style="color: var(--semeris-neutral-gray);">travel_explore</i> Ad-hoc Research</li>
          <li><i class="material-icons" style="color: var(--semeris-neutral-gray);">assignment_turned_in</i> Checklist Review</li>
          <li><i class="material-icons" style="color: var(--semeris-neutral-gray);">new_releases</i> What's New?</li>
          <li><i class="material-icons" style="color: var(--semeris-neutral-gray);">manage_search</i> Find Similar Language</li>
          <li><i class="material-icons" style="color: var(--semeris-neutral-gray);">dataset</i> Extract Tabular Data</li>
          <li><i class="material-icons" style="color: var(--semeris-neutral-gray);">content_cut</i> Gather and Export Language</li>
        </ul>
    `,
  },
  {
    title: 'Powerful Research Tools',
    intro: `
        <p>With such a <b>wealth of tools</b>, it might take a moment to get familiar with them all.</p>
        <p>Mastering them over time will empower you to interact with deals and documents at <b>superhuman speeds</b>.</p>
        <p><i>Thank you for taking this tour. Now, dive deep into the deals and unearth insights.</i></p>
    `,
  },
];
